const themes = {
  pet: {
    primary: "#FFCC02",
    secondary: "#FFCC02",
    yellow: "#FFCC02",
    lightYellow: "#fff4c7",
    accent: "#007a77",
    name: "pet",
  },
  equi: {
    primary: "#2D68C4",
    secondary: "#2D68C4",
    yellow: "#2D68C4",
    lightYellow: "#e0ecff",
    accent: "#1a4a8a",
    name: "equi",
  },
};

export function getTheme(tipo) {
  return themes[tipo] || themes.pet;
}

// default export para retrocompatibilidade
const colors = themes.pet;
export default colors;
